//CRN_20260317 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { EncryptionService } from '../../general/encryption-service';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { Observable, lastValueFrom, map, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { TypeMessageDTO } from 'src/app/core/models/system/type/type-message.dto';

@Injectable({ providedIn: 'root' })

export class TypesMessageService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  //RBW_20261020 - Saves the system wide default wording for a message type. The grid handles the other columns;
  //               the body is edited in its own modal because it needs the insert chips and the placeholder check.
  public put(typeMessage: TypeMessageDTO): Observable<any> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(typeMessage), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.TypesMessage +
                                                              "?id=" + typeMessage.id +
                                                              "&objectEnc=" + encResult.result, undefined, {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(messageTypeIds?: number[]): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TypeMessageDTO[]>(environment.eSimApi + eSimApiPaths.TypesMessage)
             .pipe(
               map(x => (messageTypeIds ? x.filter(m => messageTypeIds.includes(m.id)) : x).map(this.idAndDescriptionConverter))
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(typeMessage: TypeMessageDTO) {
    return {id: typeMessage.id, description: typeMessage.messageType};
  }

  public idAndDescriptionLookupDataSource(messageTypeIds?: number[]): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription(messageTypeIds));
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
}
